<template>
  <a-card :bordered="false">
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="showDialog = true" type="primary" icon="plus"
        >每月导入数据上传</a-button
      >

      <!-- 导入 -->
      <a-modal
        title="上传文件"
        :visible="showDialog"
        @cancel="showDialog = false"
      >
        <a-upload-dragger
          name="file"
          :multiple="true"
          :file-list="fileList"
          accept=".xls,.xlsx"
          :before-upload="beforeUpload"
          :remove="handleRemove"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">点击或拖拽上传文件</p>
        </a-upload-dragger>
        <a
          @click="handleExportExcel('每月导入数据模板')"
          style="float: right; margin-top: 0px; cursor: pointer; color: #1890ff"
        >
          点击下载模板
        </a>
        <template slot="footer">
          <a-button key="back" @click="showDialog = false"> 取消 </a-button>
          <a-button
            :disabled="fileList.length === 0"
            :loading="uploading"
            key="submit"
            type="primary"
            icon="download"
            @click="upload"
          >
            立即发送
          </a-button>
        </template>
      </a-modal>
      <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
      <!-- 高级查询区域 -->
    </div>
    <!-- 导入 -->

    <a-table
      ref="table"
      size="middle"
      :scroll="{ x: true }"
      bordered
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange
      }"
      class="j-table-force-nowrap"
      @change="handleTableChange"
    >
    </a-table>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import { uploadAction, postAction, getAction, downFileJG } from '@/api/manage';
import { filterObj } from '@/utils/util';
export default {
  name: 'ProductsQuotationList',
  data() {
    return {
      dataSource: [], //table数据列表
      showDialog: false,
      showLead: false,
      superQueryParams: '',
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      // isorter: {
      //   column: 'createTime',
      //   // order: 'desc',
      // },
      uploading: false,
      loading: false,
      selectedRowKeys: [],
      selectionRows: [],
      fileList: [],
      // 表头
      columns: [
        {
          title: '基金代码',
          align: 'center',
          dataIndex: 'fundCode'
        },
        {
          title: '截止日期',
          align: 'center',
          sorter: true,
          dataIndex: 'endDay'
        },
        {
          title: '成立至今',
          align: 'center',
          dataIndex: 'sinceInception'
        },
        {
          title: '年初至今',
          align: 'center',
          dataIndex: 'ytd'
        },
        {
          title: '3个月',
          align: 'center',
          dataIndex: 'threeMonths'
        },
        {
          title: '6个月',
          dataIndex: 'sixMonths',
          align: 'center'
        },
        {
          title: '1年',
          dataIndex: 'oneYears',
          align: 'center'
        }
      ],
      url: {
        list:
          process.env.VUE_APP_CMS_PRODUCT + '/product/productsFundValue/list',
        importExcelUrl:
          process.env.VUE_APP_CMS_PRODUCT +
          '/product/productsFundValue/monthlyReport/importExcel', //导入
        exportsUrl:
          process.env.VUE_APP_CMS_PRODUCT +
          '/product/productsFundValue/exportMonthlyTemplateXls' //导入
      }
    };
  },
  created() {
    this.getList();
  },

  methods: {
    // 文件上传
    beforeUpload(file) {
      this.fileList = [file];
      console.log(this.fileList);
      return false;
    },
    // 删除文件
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    handleExportExcel(fileName) {
      downFileJG(this.url.exportsUrl, { selections: '' }).then(data => {
        if (!data) {
          this.$message.warning('文件下载失败');
          return;
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(
            new Blob([data], { type: 'application/vnd.ms-excel' }),
            fileName + '.xlsx'
          );
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data], { type: 'application/vnd.ms-excel' })
          );
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName + '.xls');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
          // this.searchQuery();
        }
      });
    },
    //上传
    upload() {
      let formData = new FormData();
      this.uploading = true;
      formData.set('file', this.fileList[0]);
      uploadAction(this.url.importExcelUrl, formData)
        .then(res => {
          if (res.success) {
            this.$message.success(res.message);
            this.getList();
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.uploading = false;
          this.fileList = [];
          this.showDialog = false;
          // this.searchQuery();
        });
    },
    getList() {
      let that = this;
      let params = this.getQueryParams();
      params.reportType = 1;
      getAction(that.url.list, params)
        .then(res => {
          that.loading = true;
          if (res.success) {
            that.dataSource = res.result.list;
            that.loading = false;
            that.ipagination.total = res.result.total;
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    // 获取点中时的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },

    //获取查询条件
    getQueryParams() {
      let sqp = {};
      let param = Object.assign(sqp, this.queryParam);
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.getList();
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
